import React from "react";
import FJLocalStore from "../../../../store/FJLocalStore";
import styles from './FJScrollEndTip.module.less';
import InlineSVG from "react-inlinesvg";
import FlexClipIcon from "../../../../icon/flexclip-logo.svg";
import classNames from 'classnames';

function FJScrollEndTip(props) {

	return (
		<div className={classNames(styles.end_tip, {[styles.active]: props.active})}>
			<div className={styles.scroll_end}>
				<InlineSVG src={FlexClipIcon} />
				<span className={styles.end_list}>{FJLocalStore._('end-list')}</span>
			</div>
		</div>
	)

}

export default FJScrollEndTip;